import script from "./Monitoring.vue?vue&type=script&setup=true&lang=js"
export * from "./Monitoring.vue?vue&type=script&setup=true&lang=js"

import "./Monitoring.vue?vue&type=style&index=0&id=2a552af4&scoped=true&lang=scss"

import exportComponent from "F:\\hwx\\proj\\vscode\\twzc_system_web\\dataV\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a552af4"]])

export default __exports__